<template>
    <div v-if="bizAuth.viewContract.hasRight" class="page-setting biz-lease-management-default parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <modal class="new-contract" :display="newContract"  @modalStatus="closeModal('newContract')" >
            <h1>請問您要新增哪種合約？</h1>
            <div class="content">
                <contract-type @getLink="contractLink"></contract-type>
            </div>
            <div class="btn-group">
                <router-link :to="{ name: newContractLink}">
                    <button class="default-button" @click="closeModal('newContract')">確認</button>
                </router-link>
                <button class="border-button" @click="closeModal('newContract')">取消</button>
            </div>
        </modal>
        <!-- <auto-setting-batch @saveAutoStatus="alart.success = true, msg.success = '通知設定成功'"></auto-setting-batch> -->
        <lease-process-filter :isOpen="filterStatus.process" @filterClose="closeFilterMenu"></lease-process-filter>
        <lease-be-signed-filter :isOpen="filterStatus.beSigned" @filterClose="closeFilterMenu"></lease-be-signed-filter>
        <lease-finished-filter :isOpen="filterStatus.finished" @filterClose="closeFilterMenu"></lease-finished-filter>
        <div class="tool-bar-mask"></div>
        <div class="page-header has-tab">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <!-- <div v-if="selected.process == true" class="border-button" @click="setAutoSetting">
                    通知設定
                </div>
                <div class="insert-contract" @click="newContractEvent()">
                    <img src="@/assets/img/icon/plus_white.svg" alt="">
                    新增合約
                </div> -->
                <table-search @changeWord="setFilterWord" :setDefault="isProcessDefault"></table-search>
                <div class="filter" @click="openFilter()">
                    <img src="@/assets/img/icon/filter_black.svg" alt="">
                </div>
                <dot-large-drop-menu bg="#ff9275" bgHover="#eb7859">
                    <ul >
                        <li v-if="bizAuth.createPaperContract.hasRight" @click="toPage('bizNewPaperContract')">
                            新增紙本合約
                        </li>
                        <li v-if="bizAuth.createPaperContract.hasRight" @click="toPage('bizNewEContract')">
                            新增電子合約
                        </li>
                        <router-link :to="{ name: 'bizBatchBill'}" >
                            <li>
                                批量新增帳單
                            </li>
                        </router-link>
                        <router-link v-if="bizAuth.autoCollectRentSetting.hasRight || bizAuth.collectRentNotify.hasRight " :to="{ name: 'bizBatchNotify'}" >
                            <li>
                                通知設定
                            </li>
                        </router-link>
                        <router-link :to="{ name: 'bizBatchMeterNotify'}" >
                            <li>
                                通知房客拍表設定
                            </li>
                        </router-link>
                        <li @click="$store.dispatch('setModalStatus', {state: true, type: 'bizUploadRecord'})">
                            上傳電表
                        </li>
                        
                    </ul>
                </dot-large-drop-menu >
            </div>
        </div>
        <tabs :key="componentKey">
            <tab name="正在進行" :selected="selected.process">
                <lease-process-list v-if="selected.process"></lease-process-list>
            </tab>
            <tab name="紙本確認中" :selected="selected.beSigned">
                <lease-be-signed-list v-if="selected.beSigned"></lease-be-signed-list>
            </tab>
            <tab name="結束合約" :selected="selected.finished">
                <lease-finished-list v-if="selected.finished"></lease-finished-list>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
// import AutoSettingBatch from '@/components/bussiness/widges/modals/AutoSettingBatch.vue';
import LeaseProcessList from '@/components/bussiness/mgtCategory/leaseMgt/leaseProcess/LeaseProcessList.vue';
import LeaseFinishedList from '@/components/bussiness/mgtCategory/leaseMgt/leaseFinished/LeaseFinishedList.vue';
import LeaseBeSignedList from '@/components/bussiness/mgtCategory/leaseMgt/leaseBeSigned/LeaseBeSignedList.vue';
import LeaseProcessFilter from '@/components/bussiness/mgtCategory/leaseMgt/leaseProcess/leaseProcessFilter.vue';
import LeaseBeSignedFilter from '@/components/bussiness/mgtCategory/leaseMgt/leaseBeSigned/leaseBeSignedFilter.vue';
import LeaseFinishedFilter from '@/components/bussiness/mgtCategory/leaseMgt/leaseFinished/leaseFinishedFilter.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import ContractType from '@/components/bussiness/widges/tools/ContractType.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            hash: null,
            leaseFilter: false,
            listIsFixed: false,
            alart: false,
            newContract: false,
            newContractLink: null,
            myHeight: (window.innerHeight) + 'px',
            selected: {
                process: false,
                beSigned: false,
                finished: false,
            },
            filterStatus: {
                process: false,
                beSigned: false,
                finished: false,
            },
            componentKey: 0,
        }
    },
    created (){
        this.selectTabByHash()
    },
    mounted () {
        // console.log(this.$route.query.success)
        // if( this.$route.query.success && this.$route.query.success == 1){
        //     this.alart = true
        //     this.$router.replace('/landlord/leasemanagement/home')
        // }
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.hash = val.hash
                this.forceUpdate()
                this.closeFilterMenu()
            },
            immediate: true,
            deep: true
        },
        'bizAuth.viewContract.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        toPage: function (page) {
            if(this.verifiedStatus === 'NORMAL'){
                this.$router.push({name: page})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        closeFilterMenu: function (value) {
            this.leaseFilter = value
        },
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        openFilter: function () {
            let hashTag = decodeURIComponent(this.$route.hash)
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            if( hashTag == '#正在進行' ){
                this.filterStatus.process = true
            }else if( hashTag == '#紙本確認中' ){
                this.filterStatus.beSigned = true
            }else if( hashTag == '#結束合約' ){
                this.filterStatus.finished = true
            }else{
                this.filterStatus.process = true
            }
        },
        closeFilterMenu: function (value) {
            this.$store.commit('modalStatus/set_filter_mode', false)
            this.filterStatus.process = false
            this.filterStatus.beSigned = false
            this.filterStatus.finished = false
        },
        setFilterWord: function (value) {
            let hashTag = decodeURIComponent(this.$route.hash)
            if( hashTag == '#正在進行' ){
                this.$store.dispatch('setBizLeaseProcessFilterWord', value)
            }else if( hashTag == '#紙本確認中' ){
                this.$store.dispatch('setBizLeaseBeSignedFilterWord', value)
            }else if( hashTag == '#結束合約' ){
                this.$store.dispatch('setBizLeaseFinishedFilterWord', value)
            }else{
                this.$store.dispatch('setBizLeaseProcessFilterWord', value)
            }
        },
        setAutoSetting: function () {
            this.componentKey += 1
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizAutoSettingBatch'})
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        closeAlart: function () {
            this.alart = false
        },
        newContractEvent: function () {
            this.newContract = true
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
            this.$store.commit('newContract/set_contract_status', 1)
        },
        closeModal: function (type) {
            if( type == 'newContract' ){
                this.newContract = false
                this.$store.commit('modalStatus/set_modal_mode', false)
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            }
        },
        contractLink: function (val) {
            this.newContractLink = val
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#正在進行' ){
                this.$analyticsBiz.logEvent('租約管理_正在進行', { screen_name: '租約管理_正在進行'})
                this.selected.process = true
            }else if( hashTag == '#紙本確認中' ){
                this.$analyticsBiz.logEvent('租約管理_紙本確認中', { screen_name: '租約管理_紙本確認中'})
                this.selected.beSigned = true
            }else if( hashTag == '#結束合約' ){
                this.$analyticsBiz.logEvent('租約管理_結束合約', { screen_name: '租約管理_結束合約'})
                this.selected.finished = true
            }else{
                this.$analyticsBiz.logEvent('租約管理_正在進行', { screen_name: '租約管理_正在進行'})
                this.selected.process = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.process = false
            this.selected.beSigned = false
            this.selected.finished = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        }
        
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            filterWordIsEmpty: 'GET_LEASE_MGT_FILTER_WORD_IS_EMPTY',
            isModalMode: 'GET_MODAL_MODE',
            isProcessDefault: 'GET_BIZ_LEASE_PROCESS_MGT_FILTER_DEFAULT',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED'

        })
    },
    components: {
        Tabs,
        Tab,
        LeaseBeSignedList,
        LeaseProcessList,
        LeaseFinishedList,
        LeaseProcessFilter,
        LeaseBeSignedFilter,
        LeaseFinishedFilter,
        TableSearch,
        AlartMsg,
        Modal,
        ContractType,
        // AutoSettingBatch,
        DotLargeDropMenu
    }
}
</script>
<style lang="scss">
    .biz-lease-management-default{
        .page-header{
            .btn-group{
               .border-button{
                    width: 120px;
                    padding: 13px 0;
                    margin-right: 16px;
                }
                .insert-contract{
                    display: flex;
                    align-items: center;
                    width: 92px;
                    height: 44px;
                    cursor: pointer;
                    border-radius: 4px;
                    background-color: #ff9275;
                    color: #fff;
                    margin-right: 16px;
                    padding: 0 14px;
                }
            }
        }
        .new-contract{
            .modal-content{
                width: 520px;
                height: 437px;
                padding: 0 !important;
                .detail{
                    align-items: unset !important;
                    h1{
                        margin-top: 36px;
                        margin-bottom: 40px;
                        margin-left: 32px;
                    }
                    .content{
                        padding: 0 32px 10px 32px;
                        height: 182px;
                        margin-bottom: 52px;
                    }
                    .content::-webkit-scrollbar {
                        display: none;
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                        button:first-child{
                            margin-right: 14px;
                        }
                    }
                }
                
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/leaseMgt/LeaseMgtDefault.vue